import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import { useApi } from '@fortem-monorepo/react-spa'
import { Audit } from '@fortem-monorepo/web-sdk'

export const useApproveElementMutation = () => {
  const api = useApi()

  const queryClient = useQueryClient()

  const invalidateMap: Record<Audit.ApproveElementParams['element_type'], string[]> = {
    [Audit.ELEMENT_TYPES.INSTRUMENT]: ['instruments'],
    [Audit.ELEMENT_TYPES.OLD_INSTRUMENT]: ['basketoptions'],
    [Audit.ELEMENT_TYPES.TRADE]: ['trades/newdb'],
    [Audit.ELEMENT_TYPES.OLD_TRADE]: ['trades/olddb'],
    [Audit.ELEMENT_TYPES.IC_GUIDELINE]: ['ic-guidelines', 'guidelines'],
  }

  return useMutation({
    mutationFn: (params: Audit.ApproveElementParams) => api.audit.approve(params),
    onSuccess() {
      toast.success('Element approved')
    },
    onSettled(_data, _error, params) {
      const queryKey = invalidateMap[params.element_type]
      queryClient.invalidateQueries({ queryKey })
    },
  })
}
